<fullscreen-page class="np-detail-layout">
  <div class="np-detail-left">
    <div class="np-detail-header">
      <div class="np-detail-title-row">
        <dx-button
          class="np-detail-back-btn"
          icon="chevronleft"
          stylingMode="text"
          (onClick)="goBack()"
        ></dx-button>

        <div class="np-detail-title text-truncate">
          {{ 'Update zum Golden Record' | translate }}
        </div>
      </div>
    </div>

    <div class="np-detail-body">
      <combineCatalogs class="d-block h-100"></combineCatalogs>
    </div>
  </div>

  <div class="np-detail-right-spacer"></div>

  <help-column
    class="align-self-stretch {{ systemService.showHelp ? '' : 'd-none' }}"
    style="flex: 1 1;"
  ></help-column>
</fullscreen-page>
